import { z } from "zod";
import { IntervalMark } from "./intervalMark.js";
import { KPI } from "./kpi.js";
import { PortalFeatureEnum } from "./PortalFeature.js";
import { zArr, zBool, zNullable, zNum, zObj, zOptional, zRecord, zStr } from "./zodWrapper.js";
import { JsonData } from "./common.js";
export var ThresholdType;
(function (ThresholdType) {
    ThresholdType["MIN"] = "min";
    ThresholdType["MAX"] = "max";
    ThresholdType["NONE"] = "";
    ThresholdType["DEV"] = "dev";
})(ThresholdType || (ThresholdType = {}));
export const ThresholdTypeEnum = z.nativeEnum(ThresholdType);
export const PlotConfigThreshold = zObj({
    alarm: zBool(),
    threshold_name: zStr(),
    type: ThresholdTypeEnum,
    value: zStr(),
    _id: zNum(),
});
export const PlotConfigSignal = zObj({
    aggregation: zStr(),
    color: zStr(),
    display_name: zStr(),
    sensor_name: zStr(),
    thresholds: zArr(PlotConfigThreshold),
    _id: zNum(),
});
export var BaselinesType;
(function (BaselinesType) {
    BaselinesType["MIN"] = "min";
    BaselinesType["MAX"] = "max";
    BaselinesType["AVG"] = "avg";
})(BaselinesType || (BaselinesType = {}));
export const BaselinesTypeEnum = z.nativeEnum(BaselinesType);
export var DipaiModule;
(function (DipaiModule) {
    DipaiModule["DIPAI"] = "DIPAI";
    DipaiModule["FLEET_OVERVIEW"] = "FLEET_OVERVIEW";
    DipaiModule["MAINTENANCE"] = "MAINTENANCE";
    DipaiModule["OPERATION"] = "OPERATION";
    DipaiModule["OPERATION2"] = "OPERATION2";
    DipaiModule["MAINSTAY"] = "MAINSTAY";
})(DipaiModule || (DipaiModule = {}));
export const DipaiModuleEnum = z.nativeEnum(DipaiModule);
export const Sensor = zObj({
    id: zNum(),
    display_name: zStr(),
    unit: zStr(),
    unitId: zOptional(zNum()),
    republish_list: zArr(zStr()),
    isVirtual: z.boolean(),
});
export const SensorGroup = zObj({
    id: zNum(),
    name: zStr(),
    sensorIds: zArr(zNum()),
});
export const AssetObject = zObj({
    id: zNum(),
    display_name: zStr(),
    sensors: zArr(Sensor),
    sensorGroups: zArr(SensorGroup),
    kpis: zArr(KPI),
});
export const PlantIntervalMark = z.object({
    mark: IntervalMark,
    t1: zStr(),
    t2: zStr(),
});
export const PlantObject = zObj({
    id: zNum(),
    config_version: zStr(),
    owner: zStr(),
    customer: zStr(),
    display_name: zStr(),
    mmsi: zOptional(zNum()),
    imo: zNullable(zNum()),
    assets: zArr(AssetObject),
    kpis: zArr(KPI),
    features: zOptional(zArr(PortalFeatureEnum)),
    marks: zArr(PlantIntervalMark),
    metaData: zNullable(JsonData),
    vesselType: z.nullable(z.string()),
    deadWeightTonnes: z.nullable(z.number()),
    grossTonnage: z.nullable(z.number()),
    bollardPullTonnes: z.nullable(z.number()),
    cargoHoldM3: z.nullable(z.number()),
});
export const DeviceStatusObject = zObj({
    name: zStr(),
    diskUsage: zNum(),
    plantName: zStr(),
    timestampLastDeviceMessage: zOptional(zStr()),
    timestampLastSensorMessage: zOptional(zStr()),
    timestampLastGitCommit: zOptional(zStr()),
    timestampLastDockerRestart: zOptional(zStr()),
    timestampLastDockerBuild: zOptional(zStr()),
    streamOnline: zOptional(zBool()),
});
export const CustomerData = z.lazy(() => zObj({
    module: DipaiModuleEnum,
    clients: zRecord(zStr(), // affiliation,
    CustomerData),
    plants: zRecord(zStr(), // plantName
    PlantObject),
    features: zArr(z.string()),
    companyId: zNum(),
}));
export const AppStructure = zRecord(zStr(), // affiliation
CustomerData);
//# sourceMappingURL=types.js.map